import React from "react";

interface Citation {
  id: number;
  text: string;
}

interface CitationsProps {
  items: Citation[];
}

const S_COLOR = "#d4af37";

/**
 * This component is used to match citations with any citation in the contect
 * we are converting docs into static web page, so for citations,
 * instead of finding citation and implementing each citation, we pass paragraph into this function
 * detect the citation format label , i.e, [1], [2],
 * then assume it's citation and replace with this function
 */
const Citations: React.FC<CitationsProps> = ({ items }) => {
  const handleScrollToInText = (id: number) => {
    const ref = document.querySelector(`[data-citation="${id}"]`);
    if (ref) {
      ref.scrollIntoView({ behavior: "smooth", block: "center" });
      ref.classList.add("highlight-citation");
      setTimeout(() => ref.classList.remove("highlight-citation"), 1500);
    }
  };

  return (
    <div className="citations-container mt-5 pt-3">
      <h3
        className="fw-bold mb-3"
        style={{
          borderLeft: `4px solid ${S_COLOR}`,
          paddingLeft: 12,
          color: "#222",
        }}
      >
        Citations
      </h3>
      <ul className="list-unstyled mb-3">
        {items.map((c) => (
          <li key={c.id} id={`citation-${c.id}`} className="citation-item">
            <span
              role="button"
              onClick={() => handleScrollToInText(c.id)}
              className="citation-number"
            >
              [{c.id}]
            </span>{" "}
            {c.text}
          </li>
        ))}
      </ul>

      <style>{`
        .citations-container {
          background: #fafafa;
          border: 1px solid #eee;
          border-radius: 8px;
          padding: 1.5rem;
        }
        .citation-item {
          font-size: 0.95rem;
          line-height: 1.6;
          color: #333;
          margin-bottom: 0.6rem;
          border-left: 3px solid transparent;
          padding-left: 0.5rem;
          transition: border-color 0.2s ease;
        }
        .citation-item:hover {
          border-color: ${S_COLOR};
        }
        .citation-number {
          color: ${S_COLOR};
          font-weight: 600;
          margin-right: 6px;
          cursor: pointer;
        }
        .highlight-citation {
          background-color: rgba(212, 175, 55, 0.15);
          transition: background-color 1s ease;
        }
      `}</style>
    </div>
  );
};

export default Citations;
